import type {SidebarItem} from './types'

export const LIGHT_THEME_LABEL = 'Light Peacock'
export const DARK_THEME_LABEL = 'Dark Peacock'

export const PROFILE_MENU_WIDTH = 370
export const PROFILE_MENU_TOP_OFFSET = 70
export const PROFILE_MENU_RIGHT_OFFSET = -45
export const PROFILE_NAME_MAX = 22
export const PROFILE_EMAIL_MAX = 40

export const APP_LOGO_PROPS = {
  appName: 'DevLens',
  customLogo: {
    src: '/logo.svg',
    alt: 'App Logo',
    width: 100,
  },
  iconProps: {
    icon: 'apps',
  },
  showAppName: true,
  showCustomLogo: false,
  showIcon: true,
} as const

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'home',
    url: '/',
  },
  {
    id: 'se-metrics',
    label: 'SE Metrics',
    icon: 'timeline',
    url: '/se-metrics',
  },
  {
    id: 'ai-productivity',
    label: 'AI Productivity & Adoption Metrics',
    icon: 'track_changes',
    url: '/ai-productivity',
  },
  {
    id: 'manage-tag',
    label: 'Manage Licenses & Tag',
    icon: 'supervised_user_circle',
    url: '/manage-tag',
  },
  {
    id: 'agile-metrics',
    label: 'Agile Metrics',
    icon: 'supervised_user_circle',
    url: '/agile-metrics',
  },
]
